import { businessAreasRepo } from '@/constants/providers';
import { CompanyKeys } from '@/modules/Companies/queries';
import { OrganizationKeys } from '@/modules/Organizations/queries/keys';
import { TaskKey } from '@/modules/Tasks/queries';
import { UserKey } from '@/modules/Users/queries/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { AttachUserBusinessAreaModel } from '../types/attach-user-businessArea-model';
import { BusinessAreasKey } from './keys';

export const useAttachUserBusinessArea = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation<void, unknown, AttachUserBusinessAreaModel>(
    (attachUserBusinessArea) =>
      businessAreasRepo.attachUserBusinessArea(attachUserBusinessArea),
    {
      onError: () => {
        toast.error(t('error.associate_user_business_area'));
      },
      onSuccess: () => {
        queryClient.invalidateQueries(OrganizationKeys.ALL);
        queryClient.invalidateQueries(BusinessAreasKey.ALL);
        queryClient.invalidateQueries(CompanyKeys.ALL);
        queryClient.invalidateQueries(TaskKey.ALL);
        queryClient.invalidateQueries(UserKey.ALL);
      },
    },
  );
};
